import { InjectionToken } from "@angular/core";

export const DIALOG_VIEWER_TOKEN = new InjectionToken<string>('');